import React, { ReactNode, useContext } from 'react'
import { MasterDataContext } from '../contexts/master_data_context'
import { useEffect } from 'react'
import { useState } from 'react'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { useFetchTagsApi } from 'api/tag'
import { Tag } from 'entities/tag'
import { useFetchChoicesApi } from 'api/choice'
import { useFetchReagentItemsApi } from 'api/reagent_item'
import { ReagentItemSearchForm } from 'entities/reagent_item'
import { TaskSetSearchForm } from 'entities/task_set'
import { useFetchTaskSetsApi } from 'api/task_set'
import { useFetchUserGroupsApi } from 'api/user_group'
import { GlobalStateContext } from 'contexts/global_state_context'

type MasterDataContainerProps = {
    children: ReactNode
}

const MasterDataContainer: React.FC<MasterDataContainerProps> = (props: MasterDataContainerProps) => {
    const globalState = useContext(GlobalStateContext)
    const tagsApi = useFetchTagsApi()
    const [probeTags, setProbeTags] = useState<Tag[]>([])
    const choicesApi = useFetchChoicesApi()
    const reagentItemsSearchForm = useForm<ReagentItemSearchForm>({ perPage: 100000, isUsing: true })
    const reagentItemsApi = useFetchReagentItemsApi(reagentItemsSearchForm)
    const taskSetSearchForm = useForm<TaskSetSearchForm>({
        incomplete: true,
        perPage: 100000,
        userGroupId: globalState.user.userGroups?.map((ug) => ug.id).join(','),
    })
    const taskSetsApi = useFetchTaskSetsApi(taskSetSearchForm)
    const userGroupsApi = useFetchUserGroupsApi()

    useEffect(() => {
        tagsApi.execute()
        choicesApi.execute()
        reagentItemsApi.execute()
        taskSetsApi.execute()
        userGroupsApi.execute()
    }, [])

    const reloadChoices = () => {
        choicesApi.execute()
    }

    const reloadReagentItems = () => {
        reagentItemsApi.execute()
    }

    const reloadTaskSets = () => {
        taskSetsApi.execute()
    }

    useEffectSkipFirst(() => {
        if (tagsApi.isSuccess()) {
            const probeTags: Tag[] = []
            tagsApi.response.results.map((tag) => {
                if (tag.type === 'probe') {
                    probeTags.push(tag)
                }
            })
            setProbeTags(probeTags)
        }
    }, [tagsApi.loading])

    return (
        <MasterDataContext.Provider
            value={{
                probeTags: probeTags,
                choices: choicesApi.response.results,
                reloadChoices: reloadChoices,
                reagentItems: reagentItemsApi.response.results,
                reloadReagentItems: reloadReagentItems,
                taskSets: taskSetsApi.response.results,
                reloadTaskSets: reloadTaskSets,
                userGroups: userGroupsApi.response.results,
            }}
        >
            {props.children}
        </MasterDataContext.Provider>
    )
}

export default MasterDataContainer
